import { AnimatePresence, motion, MotionConfig } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";
import { customTransition } from "../lib/animations";
import Menu from "../components/ui/Menu";
import { BarTopComponent } from "../components/ui/BarTop";

export const PrivateLayout = () => {
  const path = useLocation();

  return (
    <MotionConfig transition={customTransition}>
      {/* Contenedor Principal (Reemplaza el body del HTML) */}
      <div className="flex h-screen w-screen overflow-hidden bg-slate-50 font-sans text-slate-800 antialiased ">

        {/* Sidebar Estático */}
        <Menu />

        {/* Contenedor Derecho (Header + Contenido) */}
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-slate-50/70 pb-5">

          {/* Header Superior Estático */}
          <BarTopComponent />

          {/* Área de Contenido (Aquí va el Outlet animado y el scroll) */}
          <main className="flex-1 overflow-y-auto p-4 md:px-8 md:py-7 pb-5">
            {/* Se usa mode="wait" para que la vista vieja salga antes de que entre la nueva */}
            <AnimatePresence mode="wait">
              <motion.div
                key={path.pathname}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="h-full w-full space-y-6"
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </main>

        </div>


      </div>
    </MotionConfig>
  );
};
